module.exports = "/static/assets/329ed0ca87b67705aa4a08eef0bddde7.png";